import {
    getFlagByLocale,
    type SupportedLocales,
} from "@app/shared/utils/locales";
import { Chip } from "@design-system/Inputs/Chip";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "../../i18n";

type LocaleChipSelectProps = {
    locale: SupportedLocales;
    setLocale: (locale: SupportedLocales) => void;
    availableLocales: SupportedLocales[];
};
const LocaleChipSelect: FC<LocaleChipSelectProps> = ({
    locale,
    setLocale,
    availableLocales,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);
    const localeFlag = getFlagByLocale(locale);

    const options = availableLocales.map((locale) => ({
        id: locale,
        name: t(keys[locale]),
        icon: getFlagByLocale(locale),
    }));

    const handleValueChange = (value: string[]) => {
        if (!value[0]) return;
        setLocale(value[0] as SupportedLocales);
    };

    return availableLocales.length === 1 ? (
        <Chip className="w-fit">
            <Chip.Icon name={localeFlag} />
            <Chip.Label>{t(keys[locale])}</Chip.Label>
        </Chip>
    ) : (
        <Dropdown
            closeOnValueChange
            onValueChange={handleValueChange}
            selectType="single"
            value={[locale]}
        >
            <Dropdown.Trigger asChild>
                <Chip className="w-fit hover:cursor-pointer">
                    <Chip.Icon name={localeFlag} />
                    <Chip.Label>{t(keys[locale])}</Chip.Label>
                    <Chip.Icon name="chevronDown" />
                </Chip>
            </Dropdown.Trigger>
            <Dropdown.Content hasPortal align="start">
                {options?.map((option) => (
                    <Dropdown.SelectableItem key={option.id} value={option.id}>
                        <Dropdown.ItemIcon name={option.icon} />
                        <Dropdown.ItemText>{option.name}</Dropdown.ItemText>
                        <Dropdown.SelectedIndicator />
                    </Dropdown.SelectableItem>
                ))}
            </Dropdown.Content>
        </Dropdown>
    );
};

export default LocaleChipSelect;
